import React, { memo } from 'react'
import { Stack } from '@mui/material'

import TransactionsTable from './TransactionsTable'
import PageTitle from '../shared/pageTitle/PageTitle'

const Transactions = ({ t, ...restProps }) => {
  const pageTitle = t('navigation.transaction-history')
  return (
    <>
      <PageTitle title={pageTitle} />
      <Stack spacing={2.5} sx={{ mb: { xs: 3, md: 5 } }}>
        <TransactionsTable t={t} {...restProps} />
      </Stack>
    </>
  )
}

export default memo(Transactions)
